import type { ComponentType } from 'react';
import { ErrorTrackingClient, ErrorTrackingProvider } from '@squareup/service-error-tracking';
import { TrackingProvider } from '@squareup/service-event-tracking';
import { SessionProvider, useSession } from '@squareup/service-session';
import { UserDataProvider, useUserData } from '@squareup/service-user-data';
import { ToastProvider } from '@squareup/shared-ui-react';
import { getEnvironment } from '@squareup/util-environment';

const CASH_LOCAL_SELLER_SENTRY_DSN =
  'https://b6f260c26cf399efd32aaf48a01a0809@o160250.ingest.us.sentry.io/4509991002636288';

const errorClient = new ErrorTrackingClient({
  environment: getEnvironment(),
  dsn: CASH_LOCAL_SELLER_SENTRY_DSN,
  release: '',
});

function ProvidersWrapper({ children }: { children: React.ReactNode }) {
  const session = useSession();
  const userData = useUserData();

  return (
    <ErrorTrackingProvider client={errorClient} session={session}>
      <TrackingProvider
        application={{ name: 'app-dashboard' }}
        environment={getEnvironment()}
        session={session}
        userData={userData}
      >
        <ToastProvider applyHighZIndex={false}>
          {children}
        </ToastProvider>
      </TrackingProvider>
    </ErrorTrackingProvider>
  );
}

export function withProviders<P extends object>(
  Component: ComponentType<P>,
): ComponentType<P> {
  return function ComponentWithProviders(props: P) {
    return (
      <SessionProvider>
        <UserDataProvider>
          <ProvidersWrapper>
            <Component {...props} />
          </ProvidersWrapper>
        </UserDataProvider>
      </SessionProvider>
    );
  };
}
